export default "__VITE_ASSET__b5ed530a__"